function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var $4301262d71f567b9$exports = require("./utils.main.js");
var $cpRwL$internationalizeddate = require("@internationalized/date");
var $cpRwL$reactstatelyutils = require("@react-stately/utils");
var $cpRwL$react = require("react");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useCalendarState", function () {
  return $6adad0c8536fc209$export$6d095e787d2b5e1f;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $6adad0c8536fc209$export$6d095e787d2b5e1f(props) {
  var defaultFormatter = (0, $cpRwL$react.useMemo)(function () {
    return new (0, $cpRwL$internationalizeddate.DateFormatter)(props.locale);
  }, [props.locale]);
  var resolvedOptions = (0, $cpRwL$react.useMemo)(function () {
    return defaultFormatter.resolvedOptions();
  }, [defaultFormatter]);
  var locale = props.locale,
    createCalendar = props.createCalendar,
    _props$visibleDuratio = props.visibleDuration,
    visibleDuration = _props$visibleDuratio === void 0 ? {
      months: 1
    } : _props$visibleDuratio,
    minValue = props.minValue,
    maxValue = props.maxValue,
    selectionAlignment = props.selectionAlignment,
    isDateUnavailable = props.isDateUnavailable,
    _props$pageBehavior = props.pageBehavior,
    pageBehavior = _props$pageBehavior === void 0 ? 'visible' : _props$pageBehavior;
  var calendar = (0, $cpRwL$react.useMemo)(function () {
    return createCalendar(resolvedOptions.calendar);
  }, [createCalendar, resolvedOptions.calendar]);
  var _props_defaultValue;
  var _ref = (0, $cpRwL$reactstatelyutils.useControlledState)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange),
    _ref2 = _slicedToArray(_ref, 2),
    value = _ref2[0],
    setControlledValue = _ref2[1];
  var calendarDateValue = (0, $cpRwL$react.useMemo)(function () {
    return value ? (0, $cpRwL$internationalizeddate.toCalendar)((0, $cpRwL$internationalizeddate.toCalendarDate)(value), calendar) : null;
  }, [value, calendar]);
  var timeZone = (0, $cpRwL$react.useMemo)(function () {
    return value && 'timeZone' in value ? value.timeZone : resolvedOptions.timeZone;
  }, [value, resolvedOptions.timeZone]);
  var focusedCalendarDate = (0, $cpRwL$react.useMemo)(function () {
    return props.focusedValue ? (0, $4301262d71f567b9$exports.constrainValue)((0, $cpRwL$internationalizeddate.toCalendar)((0, $cpRwL$internationalizeddate.toCalendarDate)(props.focusedValue), calendar), minValue, maxValue) : undefined;
  }, [props.focusedValue, calendar, minValue, maxValue]);
  var defaultFocusedCalendarDate = (0, $cpRwL$react.useMemo)(function () {
    return (0, $4301262d71f567b9$exports.constrainValue)(props.defaultFocusedValue ? (0, $cpRwL$internationalizeddate.toCalendar)((0, $cpRwL$internationalizeddate.toCalendarDate)(props.defaultFocusedValue), calendar) : calendarDateValue || (0, $cpRwL$internationalizeddate.toCalendar)((0, $cpRwL$internationalizeddate.today)(timeZone), calendar), minValue, maxValue);
  }, [props.defaultFocusedValue, calendarDateValue, timeZone, calendar, minValue, maxValue]);
  var _ref3 = (0, $cpRwL$reactstatelyutils.useControlledState)(focusedCalendarDate, defaultFocusedCalendarDate, props.onFocusChange),
    _ref4 = _slicedToArray(_ref3, 2),
    focusedDate = _ref4[0],
    setFocusedDate = _ref4[1];
  var _ref5 = (0, $cpRwL$react.useState)(function () {
      switch (selectionAlignment) {
        case 'start':
          return (0, $4301262d71f567b9$exports.alignStart)(focusedDate, visibleDuration, locale, minValue, maxValue);
        case 'end':
          return (0, $4301262d71f567b9$exports.alignEnd)(focusedDate, visibleDuration, locale, minValue, maxValue);
        case 'center':
        default:
          return (0, $4301262d71f567b9$exports.alignCenter)(focusedDate, visibleDuration, locale, minValue, maxValue);
      }
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    startDate = _ref6[0],
    setStartDate = _ref6[1];
  var _ref7 = (0, $cpRwL$react.useState)(props.autoFocus || false),
    _ref8 = _slicedToArray(_ref7, 2),
    isFocused = _ref8[0],
    setFocused = _ref8[1];
  var endDate = (0, $cpRwL$react.useMemo)(function () {
    var duration = _objectSpread({}, visibleDuration);
    if (duration.days) duration.days--;else duration.days = -1;
    return startDate.add(duration);
  }, [startDate, visibleDuration]);
  // Reset focused date and visible range when calendar changes.
  var _ref9 = (0, $cpRwL$react.useState)(calendar.identifier),
    _ref10 = _slicedToArray(_ref9, 2),
    lastCalendarIdentifier = _ref10[0],
    setLastCalendarIdentifier = _ref10[1];
  if (calendar.identifier !== lastCalendarIdentifier) {
    var newFocusedDate = (0, $cpRwL$internationalizeddate.toCalendar)(focusedDate, calendar);
    setStartDate((0, $4301262d71f567b9$exports.alignCenter)(newFocusedDate, visibleDuration, locale, minValue, maxValue));
    setFocusedDate(newFocusedDate);
    setLastCalendarIdentifier(calendar.identifier);
  }
  if ((0, $4301262d71f567b9$exports.isInvalid)(focusedDate, minValue, maxValue))
    // If the focused date was moved to an invalid value, it can't be focused, so constrain it.
    setFocusedDate((0, $4301262d71f567b9$exports.constrainValue)(focusedDate, minValue, maxValue));else if (focusedDate.compare(startDate) < 0) setStartDate((0, $4301262d71f567b9$exports.alignEnd)(focusedDate, visibleDuration, locale, minValue, maxValue));else if (focusedDate.compare(endDate) > 0) setStartDate((0, $4301262d71f567b9$exports.alignStart)(focusedDate, visibleDuration, locale, minValue, maxValue));
  // Sets focus to a specific cell date
  function focusCell(date) {
    date = (0, $4301262d71f567b9$exports.constrainValue)(date, minValue, maxValue);
    setFocusedDate(date);
  }
  function setValue(newValue) {
    if (!props.isDisabled && !props.isReadOnly) {
      var localValue = newValue;
      if (localValue === null) {
        setControlledValue(null);
        return;
      }
      localValue = (0, $4301262d71f567b9$exports.constrainValue)(localValue, minValue, maxValue);
      localValue = (0, $4301262d71f567b9$exports.previousAvailableDate)(localValue, startDate, isDateUnavailable);
      if (!localValue) return;
      // The display calendar should not have any effect on the emitted value.
      // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
      localValue = (0, $cpRwL$internationalizeddate.toCalendar)(localValue, (value === null || value === void 0 ? void 0 : value.calendar) || new (0, $cpRwL$internationalizeddate.GregorianCalendar)());
      // Preserve time if the input value had one.
      if (value && 'hour' in value) setControlledValue(value.set(localValue));else setControlledValue(localValue);
    }
  }
  var isUnavailable = (0, $cpRwL$react.useMemo)(function () {
    if (!calendarDateValue) return false;
    if (isDateUnavailable && isDateUnavailable(calendarDateValue)) return true;
    return (0, $4301262d71f567b9$exports.isInvalid)(calendarDateValue, minValue, maxValue);
  }, [calendarDateValue, isDateUnavailable, minValue, maxValue]);
  var isValueInvalid = props.isInvalid || props.validationState === 'invalid' || isUnavailable;
  var validationState = isValueInvalid ? 'invalid' : null;
  var pageDuration = (0, $cpRwL$react.useMemo)(function () {
    if (pageBehavior === 'visible') return visibleDuration;
    return $6adad0c8536fc209$var$unitDuration(visibleDuration);
  }, [pageBehavior, visibleDuration]);
  var _props_isDisabled, _props_isReadOnly;
  return {
    isDisabled: (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : false,
    isReadOnly: (_props_isReadOnly = props.isReadOnly) !== null && _props_isReadOnly !== void 0 ? _props_isReadOnly : false,
    value: calendarDateValue,
    setValue: setValue,
    visibleRange: {
      start: startDate,
      end: endDate
    },
    minValue: minValue,
    maxValue: maxValue,
    focusedDate: focusedDate,
    timeZone: timeZone,
    validationState: validationState,
    isValueInvalid: isValueInvalid,
    setFocusedDate: function setFocusedDate(date) {
      focusCell(date);
      setFocused(true);
    },
    focusNextDay: function focusNextDay() {
      focusCell(focusedDate.add({
        days: 1
      }));
    },
    focusPreviousDay: function focusPreviousDay() {
      focusCell(focusedDate.subtract({
        days: 1
      }));
    },
    focusNextRow: function focusNextRow() {
      if (visibleDuration.days) this.focusNextPage();else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
        weeks: 1
      }));
    },
    focusPreviousRow: function focusPreviousRow() {
      if (visibleDuration.days) this.focusPreviousPage();else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
        weeks: 1
      }));
    },
    focusNextPage: function focusNextPage() {
      var start = startDate.add(pageDuration);
      setFocusedDate((0, $4301262d71f567b9$exports.constrainValue)(focusedDate.add(pageDuration), minValue, maxValue));
      setStartDate((0, $4301262d71f567b9$exports.alignStart)((0, $4301262d71f567b9$exports.constrainStart)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
    },
    focusPreviousPage: function focusPreviousPage() {
      var start = startDate.subtract(pageDuration);
      setFocusedDate((0, $4301262d71f567b9$exports.constrainValue)(focusedDate.subtract(pageDuration), minValue, maxValue));
      setStartDate((0, $4301262d71f567b9$exports.alignStart)((0, $4301262d71f567b9$exports.constrainStart)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
    },
    focusSectionStart: function focusSectionStart() {
      if (visibleDuration.days) focusCell(startDate);else if (visibleDuration.weeks) focusCell((0, $cpRwL$internationalizeddate.startOfWeek)(focusedDate, locale));else if (visibleDuration.months || visibleDuration.years) focusCell((0, $cpRwL$internationalizeddate.startOfMonth)(focusedDate));
    },
    focusSectionEnd: function focusSectionEnd() {
      if (visibleDuration.days) focusCell(endDate);else if (visibleDuration.weeks) focusCell((0, $cpRwL$internationalizeddate.endOfWeek)(focusedDate, locale));else if (visibleDuration.months || visibleDuration.years) focusCell((0, $cpRwL$internationalizeddate.endOfMonth)(focusedDate));
    },
    focusNextSection: function focusNextSection(larger) {
      if (!larger && !visibleDuration.days) {
        focusCell(focusedDate.add($6adad0c8536fc209$var$unitDuration(visibleDuration)));
        return;
      }
      if (visibleDuration.days) this.focusNextPage();else if (visibleDuration.weeks) focusCell(focusedDate.add({
        months: 1
      }));else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
        years: 1
      }));
    },
    focusPreviousSection: function focusPreviousSection(larger) {
      if (!larger && !visibleDuration.days) {
        focusCell(focusedDate.subtract($6adad0c8536fc209$var$unitDuration(visibleDuration)));
        return;
      }
      if (visibleDuration.days) this.focusPreviousPage();else if (visibleDuration.weeks) focusCell(focusedDate.subtract({
        months: 1
      }));else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
        years: 1
      }));
    },
    selectFocusedDate: function selectFocusedDate() {
      setValue(focusedDate);
    },
    selectDate: function selectDate(date) {
      setValue(date);
    },
    isFocused: isFocused,
    setFocused: setFocused,
    isInvalid: function isInvalid(date) {
      return (0, $4301262d71f567b9$exports.isInvalid)(date, minValue, maxValue);
    },
    isSelected: function isSelected(date) {
      return calendarDateValue != null && (0, $cpRwL$internationalizeddate.isSameDay)(date, calendarDateValue) && !this.isCellDisabled(date) && !this.isCellUnavailable(date);
    },
    isCellFocused: function isCellFocused(date) {
      return isFocused && focusedDate && (0, $cpRwL$internationalizeddate.isSameDay)(date, focusedDate);
    },
    isCellDisabled: function isCellDisabled(date) {
      return props.isDisabled || date.compare(startDate) < 0 || date.compare(endDate) > 0 || this.isInvalid(date);
    },
    isCellUnavailable: function isCellUnavailable(date) {
      return props.isDateUnavailable ? props.isDateUnavailable(date) : false;
    },
    isPreviousVisibleRangeInvalid: function isPreviousVisibleRangeInvalid() {
      var prev = startDate.subtract({
        days: 1
      });
      return (0, $cpRwL$internationalizeddate.isSameDay)(prev, startDate) || this.isInvalid(prev);
    },
    isNextVisibleRangeInvalid: function isNextVisibleRangeInvalid() {
      // Adding may return the same date if we reached the end of time
      // according to the calendar system (e.g. 9999-12-31).
      var next = endDate.add({
        days: 1
      });
      return (0, $cpRwL$internationalizeddate.isSameDay)(next, endDate) || this.isInvalid(next);
    },
    getDatesInWeek: function getDatesInWeek(weekIndex) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startDate;
      // let date = startOfWeek(from, locale);
      var date = from.add({
        weeks: weekIndex
      });
      var dates = [];
      date = (0, $cpRwL$internationalizeddate.startOfWeek)(date, locale);
      // startOfWeek will clamp dates within the calendar system's valid range, which may
      // start in the middle of a week. In this case, add null placeholders.
      var dayOfWeek = (0, $cpRwL$internationalizeddate.getDayOfWeek)(date, locale);
      for (var i = 0; i < dayOfWeek; i++) dates.push(null);
      while (dates.length < 7) {
        dates.push(date);
        var nextDate = date.add({
          days: 1
        });
        if ((0, $cpRwL$internationalizeddate.isSameDay)(date, nextDate)) break;
        date = nextDate;
      }
      // Add null placeholders if at the end of the calendar system.
      while (dates.length < 7) dates.push(null);
      return dates;
    }
  };
}
function $6adad0c8536fc209$var$unitDuration(duration) {
  var unit = _objectSpread({}, duration);
  for (var key in duration) unit[key] = 1;
  return unit;
}